import { FileDownloadOutlinedIcon, ListItemText, MenuItem } from '@shared/components';

interface ExportQSetActionMenuProps {
  onClick?: () => void;
}

export default function ExportQSetActionMenu(props: Readonly<ExportQSetActionMenuProps>) {
  const { onClick } = props;

  const handleQSetExport = () => {
    onClick?.();
  };
  return (
    <MenuItem value='export-qset' onClick={handleQSetExport}>
      <FileDownloadOutlinedIcon
        sx={(theme) => ({
          width: '24px',
          height: '24px',
          mr: theme.spacing(2),
        })}
      />
      <ListItemText>Export QSet</ListItemText>
    </MenuItem>
  );
}
